import request from '@/config';
enum Apis {
	TradeCache = `/api/counterpart/getcustomlistbycache`,
}

export const GetTradeCacheListApi = (): Promise<IResponse> => request.post({ url: Apis.TradeCache, data: {} });
